import apiClient from '../lib/apiClient';

/* ── FCM token register / unregister ──────────────────────────────────────── */
export const registerFCMToken = (fcm_token) =>
  apiClient('/notifications/token', {
    method: 'POST',
    body: { fcm_token, platform: 'web' },
  });

export const removeFCMToken = (fcm_token) =>
  apiClient('/notifications/token', {
    method: 'DELETE',
    body: { fcm_token },
  });

/* ── In-app notification feed ─────────────────────────────────────────────── */
// GET /notifications/host?page=&limit=&is_read=
export const getHostNotificationsApi = (params = {}) =>
  apiClient('/notifications/host', { params });

// GET /notifications/host/unread-count → { unread: number }
export const getUnreadCountApi = () =>
  apiClient('/notifications/host/unread-count');

// PATCH /notifications/host/:id/read
export const markNotificationReadApi = (id) =>
  apiClient(`/notifications/host/${id}/read`, { method: 'PATCH' });

// PATCH /notifications/host/read-all
export const markAllNotificationsReadApi = () =>
  apiClient('/notifications/host/read-all', { method: 'PATCH' });
